"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerMaxWidth = exports.GridBreakpointsMediaUp = exports.GridBreakpointsMediaDown = exports.GridBreakpointsMax = exports.GridBreakpointsArray = exports.map = void 0;

var _styledComponentsBreakpoint = require("styled-components-breakpoint");

var map = (0, _styledComponentsBreakpoint.createMap)({
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
});
exports.map = map;
var GridBreakpointsArray = ['xs', 'sm', 'md', 'lg', 'xl'];
exports.GridBreakpointsArray = GridBreakpointsArray;
var GridBreakpointsMax = {
  xs: 319,
  sm: 575,
  md: 767,
  lg: 991,
  xl: 1199
};
exports.GridBreakpointsMax = GridBreakpointsMax;
var GridBreakpointsMediaDown = {
  xs: "@media (max-width: ".concat(GridBreakpointsMax.xs, "px)"),
  sm: "@media (max-width: ".concat(GridBreakpointsMax.sm, "px)"),
  md: "@media (max-width: ".concat(GridBreakpointsMax.md, "px)"),
  lg: "@media (max-width: ".concat(GridBreakpointsMax.lg, "px)"),
  xl: "@media (max-width: ".concat(GridBreakpointsMax.xl, "px)")
};
exports.GridBreakpointsMediaDown = GridBreakpointsMediaDown;
var GridBreakpointsMediaUp = {
  xs: "@media (min-width: ".concat(+GridBreakpointsMax.xs + 1, "px)"),
  sm: "@media (min-width: ".concat(+GridBreakpointsMax.sm + 1, "px)"),
  md: "@media (min-width: ".concat(+GridBreakpointsMax.md + 1, "px)"),
  lg: "@media (min-width: ".concat(+GridBreakpointsMax.lg + 1, "px)"),
  xl: "@media (min-width: ".concat(+GridBreakpointsMax.xl + 1, "px)")
};
exports.GridBreakpointsMediaUp = GridBreakpointsMediaUp;
var ContainerMaxWidth = {
  sm: 540,
  md: 720,
  lg: 960,
  xl: 1140
};
exports.ContainerMaxWidth = ContainerMaxWidth;